<template>
  <div class="chats" >
    <el-divider content-position="left">聊天记录</el-divider>
    <el-row class="mtb10">
      <el-col :span="20">
        <el-select style="vertical-align: middle;" clearable v-model="searchArr.contact_id" filterable remote reserve-keyword placeholder="输入群名搜素" size="mini" :remote-method="searchNameremoteMethod" :loading="searchLoading" @change="handleSearchNameChange">
          <el-option v-for="chat in searchChatList"
          :key="chat.wechat_id"
          :label="chat.name"
          :value="chat.wechat_id">
          </el-option>
        </el-select>
        <el-date-picker style="vertical-align: middle;" :picker-options="ysyTypeInPickerOptions" v-model="searchArr.message_time" size="mini" type="daterange" range-separator="-" value-format="yyyy-MM-dd" start-placeholder="发送日期" end-placeholder="结束日期" @change="handleSendAtChange"></el-date-picker>
        <el-popover style="vertical-align: middle;" placement="bottom-start" v-model="visible" width="320">
          <el-form :model="searchArr" ref="searchForm" label-width="80px">
            <el-form-item label="工作人员" prop="user_id">
              <el-select v-model="searchArr.user_id" placeholder="请选择工作人员筛选" filterable clearable size="mini">
                <el-option v-for="user in adminUsers" :key="user.id" :label="user.username" :value="user.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="绑定公司" prop="isBind">
              <el-select v-model="searchArr.isBind" placeholder="请选择是否绑定公司" size="mini" clearable>
                <el-option label='未绑定' :value="1"></el-option>
                <el-option label='已绑定' :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
              <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
      <el-col :span="4">
        <span>群总数：{{ chatPageOption.total }}</span>
      </el-col>
    </el-row>
    <div class="header-con">
      <el-row class="m-con">
        <el-col class="chat-list" :span="6" v-scroll-loading="chatScrollBottom" ref="chatList">
          <div class="list">
            <div class="list_chat hide-style" :class="[selectId === chat.wechat_id ? 'active' : '']" v-for="(chat, index) in chats" :key="index">
              <el-row>
                <el-col :span="6">
                  <el-image :src="chat.avatar" style="width: .8rem; height: .8rem;" fit="cover"></el-image>
                </el-col>
                <el-col :span="14" class="hide-style">
                  <el-tooltip :content="chat.name" placement="top">
                    <span style="cursor: pointer;" @click="handleMessages(chat.wechat_id, chat.name)">{{ chat.name }}</span>
                  </el-tooltip>
                  <div v-if="chat.last_chat" class="msg-content hide-style">
                    <el-tooltip v-if="chat.last_chat.message_type === 'text'" :content="chat.last_chat.content" placement="top">
                      <span>{{ chat.last_chat.message_time }}：{{ chat.last_chat.content }}</span>
                    </el-tooltip>
                    <span v-else-if="chat.last_chat.message_type === 'image'">{{ chat.last_chat.message_time }}：[图片]</span>
                  </div>
                </el-col>
                <el-col :span="4">
                  <i style="color: #5789f4" v-if="chat.is_company_bind" class="el-icon-check"></i>
                  <el-dropdown trigger="click" @command="handleCommand" class="more-icon">
                    <span class="el-dropdown-link"><i class="el-icon-s-fold"></i></span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{action: 'bind', id: chat.wechat_id, index: index}">绑定公司</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
              <el-divider style="margin: 0;"></el-divider>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <chat :chatId="selectId" :chatName="selectName"></chat>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="绑定公司"
      :visible.sync="bindDialogVisible"
      width="40%"
      :before-close="handleBindClose">
      <el-select v-model="companyId" filterable remote reserve-keyword placeholder="输入公司" size="mini" clearable :remote-method="remoteMethod" :loading="loading">
        <el-option v-for="company in companys"
        :key="company.id"
        :label="company.company_name"
        :value="company.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleBindSub">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Chat from 'common/Chat'
import {fscDate} from '../../../static/mixins/fastChooseDate'
export default {
  name: 'Chats',
  mixins: [fscDate],
  components: {
    Chat
  },
  data () {
    return {

      searchArr: {
        contact_id: '',
        isBind: '',
        user_id: '',
        message_time: ''
      },
      visible: false,
      adminUsers: [],
      searchLoading: false,
      searchChatList: [],
      selectId: null,
      selectName: null,
      formData: null,
      selectCom: {
        id: null,
        company_name: null
      },
      chats: [],
      companies: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示条数
      },
      chatPageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示条数
      },
      itemForm: {
        is_allot: '1',
        user_id: null,
        handle_time: null,
        place_id: null,
        company_id: null,
        order_id: null,
        entries_type: null,
        item_content: '',
        cates: []
      },
      users: [],
      places: [],
      orders: [],
      licenseList: [],
      itemContent: [],
      bindDialogVisible: false,
      companyId: null,
      bindChatId: null,
      bingChatIndex: null,
      companys: [],
      is_checked: false,
      loading: false,
      itemDrawer: false,
      messageLoading: false,
      toBottom: true,
      oldHeight: 0,
      complete: false,
      chatComplete: false,
      chatLoading: false
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getChats (isSearch) {
      isSearch = isSearch || false
      this.$axios.get('/api/admin/chats?page=' + this.chatPageOption.currentPage + this.searchStr)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            if (!isSearch) {
              this.chats.push(...data.data.group)
              this.chatLoading = true
            } else {
              this.chats = data.data.group
              this.chatLoading = false
            }

            this.chatComplete = data.data.group.length === 0
            this.adminUsers = data.data.adminUsers
            this.getCount()
            this.setChats(data.data.group)
          }
        })
    },
    setChats (data) {
      let chatIds = []
      for (var i = 0; i < data.length; i++) {
        chatIds.push(data[i].chat_id)
      }

      this.$axios.post('/api/admin/chats/setChats', {chatIds: chatIds}, {loadingClose: true})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            for (let i = 0; i < data.data.length; i++) {
              for (let j = 0; j < this.chats.length; j++) {
                if (this.chats[j].chat_id === data.data[i].chatId) {
                  this.chats[j].is_company_bind = data.data[i].is_company_bind
                  this.chats[j].last_chat = data.data[i].last_chat
                }
              }
            }
          }
        })
    },
    getCount () {
      this.$axios.get('/api/admin/chats/getCount?page=' + this.chatPageOption.currentPage + this.searchStr, {loadingClose: true})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.chatPageOption.total = data.data.total
          }
        })
    },
    handleMessages (chatID, chatName) {
      this.selectId = chatID
      this.selectName = chatName
      this.itemContent = []
    },
    handleCommand (command) {
      if (command.action === 'bind') {
        this.handleBindCompany(command.id, command.index)
      }
    },
    handleBindCompany (chatID, index) {
      this.$axios.get('/api/admin/chat/company/' + chatID)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.bindChatId = chatID
            this.bingChatIndex = index
            this.bindDialogVisible = true
            if (data.data.company) {
              this.companys.push(data.data.company)
              this.companyId = data.data.companyId
            }
          }
        })
    },
    handleBindClose (done) {
      this.bindChatId = null
      this.companyId = null
      this.bingChatIndex = null
      this.companys = []
      done()
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchCompanys(query)
        }, 200)
      } else {
        this.companys = []
      }
    },
    searchCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.companys = data.data.companies
          }
        })
    },
    handleBindSub () {
      if (!this.bindChatId) {
        this.$message.error('请求参数错误，请刷新重试')
        return
      }

      if (!this.companyId) {
        this.$message.error('请选择公司')
        return
      }

      this.$axios.post('/api/admin/chat/company/bind', {bindChatId: this.bindChatId, companyId: this.companyId})
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.chats[this.bingChatIndex].is_company_bind = true
            this.bindDialogVisible = false
            this.bindChatId = null
            this.companyId = null
            this.bingChatIndex = null
            this.companys = []
            this.$message.success(data.msg)
          }
        })
    },
    handleIsBindChange (val) {
      this.selectId = null
      this.selectName = null
      this.chatPageOption.currentPage = 1
      this.getChats(true)
    },
    handleSendAtChange (val) {
      this.selectId = null
      this.selectName = null
      this.chatPageOption.currentPage = 1
      this.getChats(true)
    },
    chatScrollBottom () {
      let scrollTop = this.$refs.chatList.$el.scrollTop
      let height = this.$refs.chatList.$el.scrollHeight
      let clientHeight = this.$refs.chatList.$el.clientHeight

      if (scrollTop + clientHeight === height && this.chatLoading) {
        if (!this.chatComplete) this.chatPageOption.currentPage++
        this.getChats()
      }

      this.chatLoading = true
    },
    searchNameremoteMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchChats(query)
        }, 200)
      } else {
        this.users = []
      }
    },
    searchChats (query) {
      this.$axios.get('/api/admin/timeout_messages/searchChats/' + query)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.searchChatList = data.data
          }
        })
    },
    handleSearchNameChange (val) {
      this.selectId = null
      this.selectName = null
      this.chatPageOption.currentPage = 1
      this.getChats(true)
    },
    resetForm (formName) {
      this.searchArr.contact_id = ''
      this.searchArr.isBind = ''
      this.searchArr.message_time = ''
      this.$refs[formName].resetFields()
      this.selectId = null
      this.selectName = null
      this.chats = []
      this.chatPageOption.currentPage = 1
      this.visible = false
      this.getChats(true)
    },
    submitForm (formName) {
      this.selectId = null
      this.selectName = null
      this.chatPageOption.currentPage = 1
      this.visible = false
      this.getChats(true)
    }
  },
  mounted () {
    this.getChats()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-form-item
    margin-bottom: .1rem
  .chats
    marginLeft()
    .m-tabs-content
      padding: 0 .2rem 0 .4rem
      .m-label
        line-height: .64rem
      .el-row
        margin-bottom: .4rem
    .drawer-content
      padding: 0 .4rem 0 .4rem
    .m-label
      line-height: .64rem
    .mtb10
      margin-bottom: .2rem
    .mtb30
      margin-bottom: .6rem
    .tr
      text-align: right
    .mb-0
      margin-bottom: 0 !important
    .m-con
      background-color: #fff
      border-radius: .2rem .2rem 0 0
    .active
      color: #409eff
    .chat-list
      min-height: calc(100vh - 210px)
      height: 6rem
      padding-right: 12px
      border-right: 1px solid #ebebeb
      overflow-y: auto
    .list
      margin-top: .3rem
      .el-divider--horizontal
        margin: 0
    .list_chat
      margin-top: .2rem
      user-select: none
    .list_chat:hover
      color: #409eff
    .hide-style
      display: inherit
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .messages-list
      min-height: calc(100vh - 210px)
      height: 6rem
      overflow-y: auto
      .messages-con
        padding: .4rem
        .message
          padding: .2rem
        .image_con
          padding: .2rem
      .infinite-item-content
        display: inline-block
        margin-top: .2rem
        padding: 0 .36rem 0 .36rem
        line-height: .9rem
        background-color: #eef0f5
      .popper__arrow
        position: absolute
        top: .04rem
        left: .36rem
        display: block
        margin-right: .06rem
        border-color: transparent
        border-style: solid
        border-width: .18rem
        border-top-width: 0
        border-bottom-color: #eef0f5
        filter: drop-shadow(0 2px 12px rgba(0,0,0,.03))
    .more-icon
      float: right
      color: #5789F4
      cursor: pointer
    .msg-content
      padding-top: .2rem
      color: #ff6a00
    .el-dialog .el-select
      width: 100%
    .el-input
      width: auto
</style>



// WEBPACK FOOTER //
// src/pages/conversation/Chats.vue